import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Row, Col, Button, Card, Spinner, InputGroup } from "react-bootstrap";
import { FaTrash, FaPlus, FaImage, FaFile, FaArrowLeft } from "react-icons/fa";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";

const ProfileEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);

  const headers = {
    "auth-token": authToken,
    "authorization": accessToken
  };

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  const [loading, setLoading] = useState(false);
  const [loadingGrades, setLoadingGrades] = useState(false);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [fetchingDetails, setFetchingDetails] = useState(false);

  const [grades, setGrades] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [formData, setFormData] = useState({
    registration_number: "",
    school_code: "",
    school_name: "",
    password: "",
    email: "",
    mobile: "",
    country_code: "+91",
    address: "",
    school_type: "",
    no_of_student: "",
    grades: [],
    contact_persons: [{ name: "", designation: "", email: "", phone: "" }],
    fax: "",
    city: "",
    state: "",
    country: "",
    zip_code: "",
    website: "",
    social_link: "",
    established_year: "",
    no_of_teacher: "",
    logo: null,
    documents: null
  });

  const [errors, setErrors] = useState({});
  const [existingFiles, setExistingFiles] = useState({
    logo: null,
    documents: null
  });
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    fetchGrades();
    fetchCountries();
  }, []);

  useEffect(() => {
    if (id) {
      fetchSchoolDetails();
    }
  }, [id]);

  useEffect(() => {
    if (formData.country) {
      fetchStates(formData.country);
      setFormData(prev => ({ ...prev, state: "", city: "" }));
      setCities([]);
    }
  }, [formData.country]);

  useEffect(() => {
    if (formData.state) {
      fetchCities(formData.state);
      setFormData(prev => ({ ...prev, city: "" }));
    }
  }, [formData.state]);

  const fetchSchoolDetails = async () => {
    setFetchingDetails(true);
    try {
      const response = await APIServices.get(
        `/admin/school/details/${id}`,
        headers
      );

      if (response?.data?.status === true) {
        const schoolData = response?.data?.data;

        const gradeIdsArray = schoolData.grade_ids ? schoolData.grade_ids.split(',').map(String) : [];

        let contactPersons = [{ name: "", designation: "", email: "", phone: "" }];
        if (schoolData.contact_persons && schoolData.contact_persons.length > 0) {
          contactPersons = schoolData.contact_persons;
        }

        setFormData({
          registration_number: schoolData.registration_number || "",
          school_code: schoolData.school_code || "",
          school_name: schoolData.school_name || "",
          password: "",
          email: schoolData.email || "",
          mobile: schoolData.mobile || "",
          country_code: schoolData.country_code || "+91",
          address: schoolData.address || "",
          school_type: schoolData.school_type || "",
          no_of_student: schoolData.no_of_student || "",
          grades: gradeIdsArray,
          contact_persons: contactPersons,
          fax: schoolData.fax || "",
          city: schoolData.city_id || "",
          state: schoolData.state_id || "",
          country: schoolData.country_id || "",
          zip_code: schoolData.zip_code || "",
          website: schoolData.website || "",
          social_link: schoolData.social_link || "",
          established_year: schoolData.established_year || "",
          no_of_teacher: schoolData.no_of_teacher || "",
          logo: null,
          documents: null
        });

        setExistingFiles({
          logo: schoolData.logo || null,
          documents: schoolData.documents || null
        });

        if (schoolData.country_id) {
          await fetchStates(schoolData.country_id);
        }

        if (schoolData.state_id) {
          await fetchCities(schoolData.state_id);
        }
      }
    } catch (error) {
      console.error("Error fetching school details:", error);
      showToast("Error fetching school details", "error");
    } finally {
      setFetchingDetails(false);
    }
  };

  const fetchGrades = async () => {
    setLoadingGrades(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/grade_list?status=Active&limit=100`,
        headers
      );

      if (response?.data?.status === true) {
        const gradesData = response?.data?.data?.grades || response?.data?.data?.data || [];
        setGrades(gradesData);
      }
    } catch (error) {
      console.error("Error fetching grades:", error);
    } finally {
      setLoadingGrades(false);
    }
  };

  const fetchCountries = async () => {
    setLoadingCountries(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/country_list`,
        headers
      );

      if (response?.data?.status === true) {
        setCountries(response?.data?.data?.countries || []);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoadingCountries(false);
    }
  };

  const fetchStates = async (countryId) => {
    setLoadingStates(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list?country_id=${countryId}`,
        headers
      );

      if (response?.data?.status === true) {
        setStates(response?.data?.list || []);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoadingStates(false);
    }
  };

  const fetchCities = async (stateId) => {
    setLoadingCities(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list?state_id=${stateId}`,
        headers
      );

      if (response?.data?.status === true) {
        setCities(response?.data?.list || []);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoadingCities(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      const file = files[0];
      setFormData({ ...formData, [name]: file });

      if (name === 'logo' && file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
        setExistingFiles(prev => ({ ...prev, logo: null }));
      } else if (name === 'documents') {
        setExistingFiles(prev => ({ ...prev, documents: null }));
      }
    } else if (name === 'grades') {
      let updatedGrades = [...formData.grades];
      if (checked) {
        updatedGrades.push(value);
      } else {
        updatedGrades = updatedGrades.filter(id => id !== value);
      }
      setFormData({ ...formData, grades: updatedGrades });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleContactPersonChange = (index, field, value) => {
    const updatedContacts = [...formData.contact_persons];
    updatedContacts[index][field] = value;
    setFormData({ ...formData, contact_persons: updatedContacts });
  };

  const addContactPerson = () => {
    setFormData({
      ...formData,
      contact_persons: [
        ...formData.contact_persons,
        { name: "", designation: "", email: "", phone: "" }
      ]
    });
  };

  const removeContactPerson = (index) => {
    const updatedContacts = formData.contact_persons.filter((_, i) => i !== index);
    setFormData({ ...formData, contact_persons: updatedContacts });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.registration_number?.trim()) {
      newErrors.registration_number = "Registration number is required";
    }
    if (!formData.school_code?.trim()) {
      newErrors.school_code = "School code is required";
    }
    if (!formData.school_name?.trim()) {
      newErrors.school_name = "School name is required";
    }
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
    }
    if (!formData.address?.trim()) {
      newErrors.address = "Address is required";
    }
    if (!formData.no_of_student) {
      newErrors.no_of_student = "Number of students is required";
    }
    if (!formData.school_type) {
      newErrors.school_type = "School type is required";
    }
    if (formData.grades.length === 0) {
      newErrors.grades = "At least one grade is required";
    }
    if (!formData.country) {
      newErrors.country = "Country is required";
    }
    if (!formData.state) {
      newErrors.state = "State is required";
    }
    if (!formData.city) {
      newErrors.city = "City is required";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      showToast("Please fill all required fields", "error");
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("registration_number", formData.registration_number);
      formDataToSend.append("school_code", formData.school_code);
      formDataToSend.append("school_name", formData.school_name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("mobile", formData.mobile);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("school_type", formData.school_type);
      formDataToSend.append("grade", formData.grades.join(","));

      if (formData.no_of_student) formDataToSend.append("no_of_student", formData.no_of_student);
      if (formData.fax) formDataToSend.append("fax", formData.fax);
      if (formData.city) formDataToSend.append("city", formData.city);
      if (formData.state) formDataToSend.append("state", formData.state);
      if (formData.country) formDataToSend.append("country", formData.country);
      if (formData.zip_code) formDataToSend.append("zip_code", formData.zip_code);
      if (formData.website) formDataToSend.append("website", formData.website);
      if (formData.social_link) formDataToSend.append("social_link", formData.social_link);
      if (formData.established_year) formDataToSend.append("established_year", formData.established_year);
      if (formData.no_of_teacher) formDataToSend.append("no_of_teacher", formData.no_of_teacher);
      if (formData.country_code) formDataToSend.append("country_code", formData.country_code);

      if (formData.contact_persons.length > 0) {
        formDataToSend.append("contact_persons", JSON.stringify(formData.contact_persons));
      }

      if (formData.logo) {
        formDataToSend.append("logo", formData.logo);
      }
      if (formData.documents) {
        formDataToSend.append("documents", formData.documents);
      }

      formDataToSend.append("id", id);

      const response = await APIServices.put(
        "/admin/school/update",
        formDataToSend,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Profile updated successfully", "success");
        setTimeout(() => {
          navigate("/admin/profile");
        }, 2000);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error saving profile:", error);
      showToast(error.response?.data?.message || "An unexpected error occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  if (fetchingDetails) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading profile details...</p>
      </div>
    );
  }

  return (
    <>
      <div className="add_school_sec">
        <div className="addmom_header d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-3">
            <Button
              variant="link"
              className="p-0 text-decoration-none"
              onClick={() => navigate("/admin/profile")}
            >
              <FaArrowLeft size={20} />
            </Button>
            <h1 className="font_blue_18 font-600">Edit School Profile</h1>
          </div>
        </div>

        <Card className="add_school_form">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <h5 className="mb-3 text-primary">Basic Information</h5>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>School Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="school_name"
                      placeholder="Enter school name"
                      value={formData.school_name}
                      onChange={handleChange}
                      isInvalid={!!errors.school_name}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.school_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>School Code <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="school_code"
                      placeholder="Enter school code"
                      value={formData.school_code}
                      onChange={handleChange}
                      isInvalid={!!errors.school_code}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.school_code}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Registration Number <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="registration_number"
                      placeholder="Enter registration number"
                      value={formData.registration_number}
                      onChange={handleChange}
                      isInvalid={!!errors.registration_number}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.registration_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter email"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">Mobile <span className="text-danger">*</span></Form.Label>
                    <InputGroup>
                      <Form.Select
                        name="country_code"
                        value={formData.country_code || "+91"}
                        onChange={handleChange}
                        style={{ maxWidth: "140px", borderRight: "2px solid #D5D4DD" }}
                        disabled={loading}
                      >
                        {countries.map((country) => (
                          <option key={country.id} value={country.phonecode}>
                            {country.name} ({country.phonecode})
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter mobile number"
                        value={formData.mobile}
                        onChange={handleChange}
                        isInvalid={!!errors.mobile}
                        disabled={loading}
                      />
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">
                      {errors.mobile}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>School Type <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="school_type"
                      value={formData.school_type}
                      onChange={handleChange}
                      isInvalid={!!errors.school_type}
                      disabled={loading}
                    >
                      <option value="">Select Type</option>
                      <option value="Private">Private</option>
                      <option value="Public">Public</option>
                      <option value="Government">Government</option>
                      <option value="International">International</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.school_type}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Established Year</Form.Label>
                    <Form.Control
                      type="text"
                      name="established_year"
                      placeholder="YYYY"
                      value={formData.established_year}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Number of Students <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="no_of_student"
                      placeholder="Enter number of students"
                      value={formData.no_of_student}
                      onChange={handleChange}
                      isInvalid={!!errors.no_of_student}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.no_of_student}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Number of Teachers</Form.Label>
                    <Form.Control
                      type="number"
                      name="no_of_teacher"
                      placeholder="Enter number of teachers"
                      value={formData.no_of_teacher}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <h5 className="mb-3 text-primary mt-3">Location Information</h5>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      isInvalid={!!errors.country}
                      disabled={loading || loadingCountries}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.country}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>State <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      isInvalid={!!errors.state}
                      disabled={loading || loadingStates || !formData.country}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>City <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      isInvalid={!!errors.city}
                      disabled={loading || loadingCities || !formData.state}
                    >
                      <option value="">Select City</option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="address"
                      placeholder="Enter address"
                      value={formData.address}
                      onChange={handleChange}
                      isInvalid={!!errors.address}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Zip Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="zip_code"
                      placeholder="Enter zip code"
                      value={formData.zip_code}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fax</Form.Label>
                    <Form.Control
                      type="text"
                      name="fax"
                      placeholder="Enter fax"
                      value={formData.fax}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Website</Form.Label>
                    <Form.Control
                      type="text"
                      name="website"
                      placeholder="Enter website URL"
                      value={formData.website}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Social Links</Form.Label>
                    <Form.Control
                      type="text"
                      name="social_link"
                      placeholder="Enter social links (comma separated)"
                      value={formData.social_link}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* Grades Section */}
              <h5 className="mb-3 text-primary mt-3">
                Grades <span className="text-danger">*</span>
              </h5>
              {errors.grades && <div className="text-danger mb-2">{errors.grades}</div>}

              <div className="grade-checkbox">
                <Form.Check
                  type="checkbox"
                  id="grade-all"
                  label="All Grades"
                  checked={formData.grades.length === grades.length && grades.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const allGradeIds = grades.map(grade => String(grade.id));
                      setFormData({ ...formData, grades: allGradeIds });
                    } else {
                      setFormData({ ...formData, grades: [] });
                    }
                  }}
                  disabled={loadingGrades || loading}
                />
              </div>
              <hr />
              <div className="row">
                {loadingGrades ? (
                  <div className="col-12 text-center py-3">
                    <Spinner animation="border" size="sm" />
                  </div>
                ) : (
                  grades.map((grade) => (
                    <div className="col-md-2 mb-2" key={grade.id}>
                      <div className="grade-checkbox">
                        <Form.Check
                          type="checkbox"
                          id={`grade-${grade.id}`}
                          label={grade.name}
                          checked={formData.grades.includes(String(grade.id))}
                          onChange={(e) => {
                            let updatedGrades = [...formData.grades];
                            if (e.target.checked) {
                              updatedGrades.push(String(grade.id));
                            } else {
                              updatedGrades = updatedGrades.filter(id => id !== String(grade.id));
                            }
                            setFormData({ ...formData, grades: updatedGrades });
                          }}
                          disabled={loadingGrades || loading}
                        />
                      </div>
                    </div>
                  ))
                )}
              </div>

              <h5 className="mb-3 text-primary mt-3">Contact Persons</h5>
              {formData.contact_persons.map((contact, index) => (
                <Card key={index} className="mb-3 p-3">
                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-2">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter name"
                          value={contact.name}
                          onChange={(e) => handleContactPersonChange(index, "name", e.target.value)}
                          disabled={loading}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-2">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter designation"
                          value={contact.designation}
                          onChange={(e) => handleContactPersonChange(index, "designation", e.target.value)}
                          disabled={loading}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-2">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter email"
                          value={contact.email}
                          onChange={(e) => handleContactPersonChange(index, "email", e.target.value)}
                          disabled={loading}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group className="mb-2">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter phone"
                          value={contact.phone}
                          onChange={(e) => handleContactPersonChange(index, "phone", e.target.value)}
                          disabled={loading}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={1} className="d-flex align-items-end">
                      {formData.contact_persons.length > 1 && (
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeContactPerson(index)}
                          disabled={loading}
                        >
                          <FaTrash />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Card>
              ))}
              <Button
                variant="outline-primary"
                size="sm"
                className="mb-3"
                onClick={addContactPerson}
                disabled={loading}
              >
                <FaPlus className="me-1" /> Add Contact Person
              </Button>

              <h5 className="mb-3 text-primary mt-3">Documents & Logo</h5>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>School Logo</Form.Label>
                    <Form.Control
                      type="file"
                      name="logo"
                      accept="image/*"
                      onChange={handleChange}
                      disabled={loading}
                    />
                    {(existingFiles.logo || imagePreview) && (
                      <div className="mt-2">
                        {existingFiles.logo && !imagePreview ? (
                          <div>
                            <img
                              src={existingFiles.logo}
                              alt="Current Logo"
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                padding: '5px'
                              }}
                            />
                            
                          </div>
                        ) : imagePreview && (
                          <div>
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                border: '2px solid #28a745',
                                padding: '5px'
                              }}
                            />
                            <div className="mt-1">
                             
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Documents</Form.Label>
                    <Form.Control
                      type="file"
                      name="documents"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      onChange={handleChange}
                      disabled={loading}
                    />
                    {(existingFiles.documents || formData.documents) && (
                      <div className="mt-2">
                        <div className="d-flex align-items-center gap-2">
                          {existingFiles.documents && !formData.documents ? (
                            <>
                              <FaFile size={24} className="text-primary" />
                              <div>
                                <a href={existingFiles.documents} target="_blank" rel="noopener noreferrer">
                                  View Current Document
                                </a>
                               
                              </div>
                            </>
                          ) : formData.documents && (
                            <>
                              <FaFile size={24} className="text-success" />
                              <span>New document selected: {formData.documents.name}</span>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <Button
                  variant="secondary"
                  onClick={() => navigate("/admin/profile")}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save Changes"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default ProfileEdit;